import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Label,
  Input,
  Form,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getFileSizeDescription } from '../../helpers/Files';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalFileSizes = ({ availableFileSizes, handleChange, fileSizes }) => {
  const intl = useIntl();

  return (
    <div className="share-file-sizes share-setting">
      <Form className="file-sizes-form">
        <ul className="file-sizes-list">
          <li>
            <div className="checkbox-wrapper">
              <Input
                type="checkbox"
                className="input-check check-l"
                id="file-size-0"
                value="original"
                checked={fileSizes.includes('original')}
                onChange={handleChange}
                disabled={!canUserManageShare()}
              />
            </div>
            <div className="checkbox-label">
              <Label htmlFor="file-size-0">
                {intl.formatMessage({ defaultMessage: 'Original size' })}
              </Label>
            </div>
          </li>
          {availableFileSizes.map(fs => (
            <li key={fs.id}>
              <div className="checkbox-wrapper">
                <Input
                  type="checkbox"
                  className="input-check check-l"
                  id={`file-size-${fs.id}`}
                  value={fs.id}
                  checked={fileSizes.includes(`${fs.id}`)}
                  onChange={handleChange}
                  disabled={!canUserManageShare()}
                />
              </div>
              <div className="checkbox-label">
                <Label htmlFor={`file-size-${fs.id}`}>
                  {fs.name}
                  <span>{getFileSizeDescription(fs)}</span>
                </Label>
              </div>
            </li>
          ))}
        </ul>
      </Form>
    </div>
  );
};

const mapStateToProps = state => ({
  availableFileSizes: state.App.fileSizes,
});

ShareModalFileSizes.propTypes = {
  availableFileSizes: PropTypes.array.isRequired,
  fileSizes: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ShareModalFileSizes);
